import { useState } from 'react';
import { getAuthHeaders, handleAuthError } from '../utils/authUtils';
import { getApiBaseUrlWithoutPath } from '../../config/environment';

const useCreateCategory = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const createCategory = async (categoryData) => {
    try {
      setLoading(true);
      setError(null);

      const headers = getAuthHeaders();
      const apiUrl = getApiBaseUrlWithoutPath();

      const response = await fetch(`${apiUrl}/api/admin/categories`, {
        method: 'POST',
        headers,
        body: JSON.stringify(categoryData)
      });

      const text = await response.text();
      let result = {};
      try {
        result = text ? JSON.parse(text) : {};
      } catch {
        result = { message: text?.slice(0, 300) || `HTTP ${response.status}` };
      }

      if (!response.ok) {
        const serverMsg =
          result.message ||
          (typeof result.error === 'string' ? result.error : result.error?.message) ||
          result.msg ||
          `Server error (${response.status})`;
        console.error('Create category failed:', response.status, result);
        handleAuthError(new Error(serverMsg), response);
      }

      if (result.success) {
        return result.data;
      }
      throw new Error(result.message || 'Failed to create category');
    } catch (error) {
      console.error('Create category error:', error);
      setError(error.message);
      throw error;
    } finally {
      setLoading(false);
    }
  };

  return { createCategory, loading, error };
};

export default useCreateCategory;


